import { useAppContext } from 'Providers/AppProvider/AppContext';

export interface PdvIdentity {
  /** Stored on every flag and every attribute decision. Email, because the queue is
   *  shared across the CFS product team and a display name is not unique. */
  id: string;
  /** What the queue shows. Falls back to the email when no full name is set. */
  name: string;
  /** False before the user resolves. Actions that record who did something stay
   *  disabled until it is true — attributing work to a guessed name is worse than
   *  making someone wait a moment for the button. */
  ready: boolean;
}

/**
 * Who is using PDV.
 *
 * Reads the signed-in user from AppProvider, the same place the rest of the webapp
 * takes it from. An earlier version read `useAuth0().user`, which carries no email
 * in this app — so every flag was filed against the literal string "rep" and
 * "Assign to me" was permanently disabled.
 *
 * Deliberately has no fallback value. If there is no user, callers disable the
 * action rather than inventing an author.
 */
export const usePdvIdentity = (): PdvIdentity => {
  const { user } = useAppContext();
  const id = user?.Email ?? '';
  return { id, name: user?.FullName || id, ready: Boolean(id) };
};
